import {ValueObject} from '@s-ui/domain'

export class UnseenSavedSearchMatchesValueObject extends ValueObject {
  /**
   * @param {Object} matchCounters
   */
}
